import { render, staticRenderFns } from "./EvalancheForm.vue?vue&type=template&id=f70fd6da&"
import script from "./EvalancheForm.vue?vue&type=script&lang=js&"
export * from "./EvalancheForm.vue?vue&type=script&lang=js&"
import style0 from "./EvalancheForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports